import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlobus = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.25 0.5C4.86547 0.5 0.5 4.86547 0.5 10.25C0.5 15.6345 4.86547 20 10.25 20C15.6345 20 20 15.6345 20 10.25C20 4.86547 15.6345 0.5 10.25 0.5Z",
			stroke: "#52AED4",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.2502 0.5C7.52812 0.5 4.96875 4.86547 4.96875 10.25C4.96875 15.6345 7.52812 20 10.2502 20C12.9722 20 15.5316 15.6345 15.5316 10.25C15.5316 4.86547 12.9722 0.5 10.2502 0.5Z",
			stroke: "#52AED4",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.75 3.75C5.5425 5.02266 7.79906 5.78156 10.2502 5.78156C12.7012 5.78156 14.9578 5.02266 16.7503 3.75M16.7503 16.7503C14.9578 15.4777 12.7012 14.7187 10.2502 14.7187C7.79906 14.7187 5.5425 15.4777 3.75 16.7503",
			stroke: "#52AED4",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.25 0.5V20M20 10.25H0.5",
			stroke: "#52AED4",
			strokeMiterlimit: 10
		})
	]
});
export default SvgGlobus;
